import type { ToolUseStatus } from '../../../contracts/harness.types';
import type { BlockStatus } from './presentation/types';

/** Map the harness tool status onto the visual states the blocks render. */
export const toBlockStatus = (status: ToolUseStatus): BlockStatus =>
  status === 'complete'
    ? 'success'
    : status === 'error'
      ? 'error'
      : status === 'cancelled'
        ? 'cancelled'
        : 'running';
